export const COLOR_START = "#FFA500A0";
export const COLOR_END = "#0077B520";
export const STROKE_COLOR_START = "#FFA500";
export const STROKE_COLOR_END = "#0077B5";
